import React, { useState, useRef, useEffect, useMemo } from "react";
import SSPCommonModal from "../../CommonComponents/SSPCommonModal/SSPCommonModal";
import { PageBar, SSPCommonButton, } from "../../CommonComponents";
import Grid from "@mui/material/Grid";
import { Box, Card, CardContent, CardHeader, Divider, Link, Button, Tooltip, Typography, IconButton, TextField, MenuItem, } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import { post } from "../../services";
import Cookies from "js-cookie";
import Loader from "../../CommonComponents/Loader";
import axios from "axios";
import { StyledInvoiceDatePicker, boxSX, styles } from './Styles'
import styled from 'styled-components';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Create, Download } from "@mui/icons-material";
import Select from "react-select";
import SearchIcon from '@mui/icons-material/Search';

const base = "https://";

const CreateProvisions = ({ token }) => {
    const id = Cookies.get("ssp_id");
    const domain_id = Cookies.get("ssp_domain_id");
    const [selectedPeriods, setSelectedPeriods] = useState([]);
    const [provisionPeriodApiList, setProvisionPeriodApiList] = useState([]);

    const [status, setStatus] = useState('pending');
    const [loading, setLoading] = useState(false);
    const [item, setItem] = useState([]);
    const [modalOpener, setmodalOpener] = useState(false);
    const [message, setmessage] = useState("");
    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [row, setRows] = useState([]);
    const [itemApiList, setitemApiList] = useState([]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));


    const itemListSelectOptions = useMemo(() => {
        return itemApiList?.map(itemName => ({
            label: itemName ? itemName.toString().trim() : "",
            value: itemName ? itemName.toString().trim() : ""
        }));
    }, [itemApiList]);

    // --- ADDED: Period Options from API ---
    const periodOptions = useMemo(() => {
        return provisionPeriodApiList?.map(p => ({
            label: p,
            value: p
        }));
    }, [provisionPeriodApiList]);

    useEffect(() => {
        rowFetch();
        getDropdownData();
    }, []);

    const getDropdownData = async () => {
        setLoading(true);
        let payload = { "action": "provision/get_dropdown_list" }

        let response = await post(
            base + "ya8zbsuisd.execute-api.ap-south-1.amazonaws.com/prod/ssp_ht_prod",
            payload,
            true,
            false
        );

        if (response?.status === "success" || response?.body?.status === "success") {
            const data = response?.body?.data || {};

            setitemApiList(data.item_with_desc || []);
            setProvisionPeriodApiList(data.provision_period || []);
            setLoading(false);
        } else {
            setmessage(response?.message || response?.body?.message || "Failed to load dropdown data.");
            setmodalOpener(true);
            setLoading(false);
        }
    }

    const rowFetch = async () => {
        let response = await post(
            base + "ya8zbsuisd.execute-api.ap-south-1.amazonaws.com/prod/ssp_ht_prod",
            { "action": "provision/upload_details", "module_name": "create_provisions" },
            true,
            false
        );
        if (response?.status === "sucess" || response?.body?.status === "success") {

            const rowsData = response?.body?.data?.map((row, index) => ({
                ...row,
                id: index + 1,
            }));
            setRows(rowsData);

        } else if (response?.status === "Error" || response?.body?.status === "error") {
            setmessage(response?.message || response?.body?.message);
            setmodalOpener(true);
        }
        else {
        }
    };

    const handleDownloadFile = async () => {
        if (!selectedPeriods || selectedPeriods.length === 0) {
            setmessage("Please select at least one provision period.");
            setmodalOpener(true);
            return;
        }
        else if (!item || item.length === 0) {
            setmessage("Please select at least one item.");
            setmodalOpener(true);
            return;
        }

        setLoading(true);
        const itemPayload = item.map(i => {
            if (i.value && i.value.includes('-')) {
                return i.value.split('-')[0].trim();
            }
            return i.value.trim();
        });

        const periodsPayload = selectedPeriods.map(p => p.value);

        let payload = {
            "action": "provision/download_past_provisions",
            "provision_period": periodsPayload,
            "item": itemPayload
        };

        let response = await post(
            base + "ya8zbsuisd.execute-api.ap-south-1.amazonaws.com/prod/ssp_ht_prod",
            payload,
            true,
            false
        );

        if (response?.status === "success" || response?.body?.status === "success") {
            window.open(response?.body?.data || response?.data);
            setSelectedPeriods([]);
            setItem([]);

            setLoading(false);
        } else {
            setmessage(response?.message || response?.body?.message);
            setmodalOpener(true);
            setLoading(false);
        }

    }
    const downloadProcessLog = async (logId) => {
        setLoading(true)

        let response = await post(
            base + "ya8zbsuisd.execute-api.ap-south-1.amazonaws.com/prod/ssp_ht_prod",
            { "action": "provision/process_log", "module_name": "create_provisions", "log_id": String(logId) }
            ,
            true,
            false
        );
        if (response?.status === "success" || response?.body?.status === "success") {
            setLoading(false)
            window.open(response?.body?.data || response?.body?.url);

        } else {
            setLoading(false)
            setmessage(response?.body?.message || response?.message);
            setmodalOpener(true);
        }
    }

    const handleUpload = async () => {
        if (selectedFile) {
            if (selectedFile instanceof File) {
                const fileExtension = selectedFile.name.split('.').pop().toLowerCase();
                if (fileExtension !== "xlsx") {
                    setmessage("Only .xlsx files are allowed.");
                    setmodalOpener(true);
                    return;
                }
            }
            setLoading(true)
            let filenameWithTimestamp;
            if (selectedFile instanceof File) {
                const timestamp = new Date()
                    .toISOString()
                    .replace(/[-:.]/g, "")
                    .slice(0, 15);
                filenameWithTimestamp = `${selectedFile?.name
                    .split(".")
                    .slice(0, -1)
                    .join(".")}_${timestamp}.${selectedFile?.name?.split(".")?.pop()}`;
            } else {
                filenameWithTimestamp = selectedFile;
            }
            let presignedUrlResponse = await post(
                base +
                "ya8zbsuisd.execute-api.ap-south-1.amazonaws.com/prod/ssp_ht_prod",
                { "action": "provision/gen_pre_url", "type": "upload", "filename": filenameWithTimestamp?.replace(/[()]/g, "") }
                ,
                true,
                false
            );
            if (presignedUrlResponse?.status === 'error') {
                setmessage(presignedUrlResponse?.data?.message);
                setmodalOpener(true);
                return
            }

            const presignedUrl = presignedUrlResponse?.body?.data;

            if (!presignedUrl) {
                console.error("Presigned URL is not valid");
                return;
            }
            if (selectedFile instanceof File) {
                const fileUploaded = await uploadFileWithPresignedUrl(
                    selectedFile,
                    presignedUrl
                );
                if (fileUploaded) {
                    let response = await post(
                        base + "ya8zbsuisd.execute-api.ap-south-1.amazonaws.com/prod/ssp_ht_prod",
                        {
                            filename: presignedUrl.fields.key,
                            "action": "provision/save_provisions",
                        },
                        true,
                        false
                    );
                    if (response?.status === "success" || response?.body?.status === "success") {

                        setLoading(false)
                        setmessage(response?.message || response?.body?.message || "File Uploaded");
                        setmodalOpener(true);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setSelectedFile(null);
                        setTimeout(() => {
                            window.location.reload();
                        }, 2000);

                    } else if (response?.status === "Error" || response?.status === "error") {
                        setLoading(false)

                        setmessage(response?.message || response?.body?.message);
                        setmodalOpener(true);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setSelectedFile(null);

                    }

                    else {
                        setLoading(false)

                        setmessage(response?.body?.message || response?.message);
                        setmodalOpener(true);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setSelectedFile(null);
                    }
                }

                if (!fileUploaded) {
                    if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                    }
                    setLoading(false)
                    setSelectedFile(null);

                    console.error("File upload failed");
                    return;
                }
            }

        } else {
            setLoading(false)
            setmessage("Please select file to upload");
            setmodalOpener(true);
        }
    }
    const uploadFileWithPresignedUrl = async (filetoUpload, generatedUrl) => {
        try {
            const fileUploadData = new FormData();
            Object.keys(generatedUrl.fields).forEach((key) => {
                fileUploadData.append(key, generatedUrl.fields[key]);
            });
            fileUploadData.append("file", filetoUpload);
            const fileUploaded = await uploadFile(generatedUrl.url, fileUploadData);
            if (fileUploaded) {
                return true;
            } else {
                console.error("File upload failed");
                return false;
            }
        } catch (error) {
            console.error("Error during file upload:", error);
            throw error;
        }
    };

    const uploadFile = async (url, formData) => {
        try {
            const response = await axios.post(url, formData);

            if (response.status === 204) {
                console.log("File upload successful with status 204");
                return true;
            }

            if (response.status >= 200 && response.status < 300) {
                console.log("File upload successful");
                return true;
            } else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        } catch (error) {
            console.error("Error during file upload:", error);
            throw error;
        }
    };
    const handleDownloadItemMaster = async () => {
        setLoading(true)
        let response = await post(
            base + "ya8zbsuisd.execute-api.ap-south-1.amazonaws.com/prod/ssp_ht_prod",
            { "action": "provision/download_item_master" },
            true,
            false
        );
        if (response?.status === "success" || response?.body?.status === "success") {
            window.open(response?.body?.data);
            setLoading(false);
        } else {
            setmessage(response?.message || response?.body?.message);
            setmodalOpener(true);
            setLoading(false);
        }
    }
    const handleDownloadSampleFile = async () => {
        setLoading(true)
        let response = await post(
            base + "ya8zbsuisd.execute-api.ap-south-1.amazonaws.com/prod/ssp_ht_prod",
            { "action": "provision/download_sample_file" },
            true,
            false
        );
        if (response?.status === "success" || response?.body?.status === "success") {
            setLoading(false)
            window.open(response?.body?.data);
        } else {
            setLoading(false)

            setmessage(response?.message || response?.body?.message);
            setmodalOpener(true);
        }

    };
    const ReasonCell = ({ value }) => {
        return (
            <Tooltip
                title={
                    <span style={{ fontSize: "16px" }}>{value}</span>
                }
            >
                <div
                    style={{
                        whiteSpace: "none",
                        textAlign: "start",
                        maxWidth: "100%",

                    }}
                >{value}</div>
            </Tooltip>
        );
    };

    const columns = [
        {
            field: 'sr_no',
            headerName: 'Sr no',
            headerAlign: 'center',
            align: 'center',
            // flex: 0.5,
            width: isMobile ? 150 : 120,
            renderCell: (params) => (
                <div>
                    {params.id}
                </div>
            )
        },
        {
            field: 'log_id',
            headerName: 'Log id',
            headerAlign: 'center',
            align: 'center',
            // flex: 0.5,
            width: isMobile ? 150 : 120,
            renderCell: (params) => (
                <div>
                    {params.value}
                </div>
            )
        },

        {
            field: "file_name",
            headerName: " File Name",
            headerAlign: "left",
            align: "left",
            width: 220,
            renderCell: (params) => <ReasonCell value={params.value ? params.value : "--"} />,
        },
        {
            field: 'created_at',
            headerName: 'Date',
            headerAlign: 'center',
            align: 'center',
            width: isMobile ? 180 : 150,
            // renderCell: (params) => <ReasonCell value={params.value ? params.value : "--"} />,
            renderCell: (params) => (
                <div style={{
                    textAlign: 'center',
                    // color: params.value === 'Success' ? 'green' : 'red',
                }}>{params.value ? params.value : "--"}</div>
            ),
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div style={{
                    textAlign: 'center', color: params.value === 'Success' ? 'green' : 'red',
                }}>{params.value}</div>
            ),
        },

        {
            field: 'affected_count',
            headerName: (
                <div style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                    No of records processed
                </div>
            ),
            width: isMobile ? 180 : 200,
            // flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div style={{ textAlign: 'center' }}>{params?.value ? params?.value : '0'}</div>
            ),
        },

        {
            field: "current_status",
            headerName: "Progress",
            headerAlign: "center",
            align: "center",
            width: isMobile ? 170 : 200,

            renderCell: (params) => {
                return (
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        width="100%"
                        height="100%"
                        textAlign="center"
                        style={{
                            lineHeight: 1.5,
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: "0.9rem",
                                // marginBottom: "4px",
                                color: params.value === 'Partial File Uploaded ' ? 'red' : params.value === 'File Uploaded' && 'green'
                            }}
                        >
                            {params.value}
                        </Typography>

                    </Box>
                );
            },
        },
        {
            field: "process_log",
            headerName: "Process Log",
            headerAlign: "center",
            width: 155,
            align: "center",

            renderCell: (params) => (
                <IconButton
                    aria-label="Download Process Log"
                    onClick={() => downloadProcessLog(params.row.log_id)}
                >
                    <Download color="primary" />
                </IconButton>
            ),
        },


    ];

    const selectStyles = {
        container: (base) => ({
            ...base,
            width: '100%',
            minWidth: '200px',
        }),
        control: (base) => ({
            ...base,
            paddingLeft: "30px",
            minHeight: "40px",
            height: "auto",
            borderColor: "black",
            backgroundColor: "white",
            alignItems: "center",
        }),
        valueContainer: (base) => ({
            ...base,
            paddingLeft: "0px",

        }),
        menu: (base) => ({ ...base, zIndex: 9999 }),
        multiValue: (base) => ({
            ...base,
            maxWidth: "100%",
        }),
    };

    return (
        <Box>
            <Loader loading={loading} />
            <PageBar
                text="Fusion : Create Provisions"
            />
            <Card sx={styles.assetmasterCard} >

                <CardHeader
                    p={2}
                    sx={styles.cardHeader}
                    title={" Upload excel containing provisioning data"}
                    titleTypographyProps={{
                        sx: { fontSize: "16px", fontWeight: "600", lineHeight: "16px", color: "#0160F1", },
                    }}
                />
                <Divider />
                <CardContent sx={styles.assetmasterCardContent} >
                    <Grid container spacing={2} >
                        <Grid item xs={12} sm={6} md={6} lg={4} xl={4} sx={styles.locContainer} >
                            <Box p={2} sx={{ ...styles.fileStyle, width: isMobile ? '90%' : '85%' }} >
                                {/* <Box p={2} sx={{ ...styles.fileStyle, width: isMobile ? '90%' : '85%' }} > */}
                                <Box p={1} sx={styles.fileInputStyle} >
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        multiple={false}
                                        onChange={(e) => {
                                            setSelectedFile(e.target.files[0]);
                                        }}

                                    />
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={2.7} xl={4} sx={{ ...styles.dwnldAssetMasterbttnStyle, marginLeft: isMobile ? 3 : 10 }} >
                            <SSPCommonButton
                                btnText="Save data"
                                btnFunction={() => {
                                    handleUpload()
                                }}
                            />
                        </Grid>

                    </Grid>
                    <Box p={1} sx={styles.buttonBox} >
                        <Link
                            component={"button"}
                            color={"#0160F1"}
                            sx={boxSX}
                            onClick={handleDownloadSampleFile}
                        >
                            {"Download Sample File"}
                        </Link>
                        <Divider
                            orientation="vertical"
                            flexItem
                            sx={styles.deviderStyle}
                        />
                        <Link
                            component={"button"}
                            color={"#0160F1"}
                            sx={boxSX}
                            onClick={handleDownloadItemMaster}
                        >
                            {"Download item master"}
                        </Link>

                    </Box>
                </CardContent>

                <CardHeader
                    p={2}
                    sx={{ ...styles.cardHeader, marginTop: 1 }}
                    title={" Download Past provisions and utilisation"}
                    titleTypographyProps={{
                        sx: { fontSize: "16px", fontWeight: "600", lineHeight: "16px", color: "#0160F1", },
                    }}
                />
                <Divider />
                <CardContent sx={{ ...styles.assetmasterCardContent, paddingTop: 4 }} >
                    {/* CHANGED: Align items to flex-end so input boxes align with button bottom */}
                    <Grid container spacing={3} alignItems="flex-end">

                        {/* CHANGED: Equal Width 5 columns */}
                        <Grid item xs={12} sm={5} md={5} lg={4} style={{ marginLeft: 15 }} >
                            <Typography sx={{ fontSize: '14px', marginBottom: '8px' }}>Provision Period:</Typography>
                            <Box sx={{ position: "relative", width: '70%', }}>
                                <SearchIcon sx={{ position: "absolute", top: "50%", left: 10, transform: "translateY(-50%)", color: "gray", zIndex: 1, }} />
                                <Select
                                    options={periodOptions}
                                    value={selectedPeriods}
                                    onChange={(selectedOptions) => setSelectedPeriods(selectedOptions || [])}
                                    isMulti
                                    isSearchable
                                    isClearable
                                    closeMenuOnSelect={false}
                                    placeholder="Select Periods"
                                    styles={selectStyles}
                                />
                            </Box>
                        </Grid>

                        {/* CHANGED: Equal Width 5 columns */}
                        <Grid item xs={12} sm={5} md={5} lg={5}>
                            <Typography sx={{ fontSize: '14px', marginBottom: '8px' }}>Item:</Typography>
                            <Box sx={{ position: "relative", width: '55%' }}>
                                <SearchIcon sx={{ position: "absolute", top: "50%", left: 10, transform: "translateY(-50%)", color: "gray", zIndex: 1, }} />
                                <Select
                                    options={itemListSelectOptions}
                                    value={item}
                                    onChange={(selectedOptions) => setItem(selectedOptions || [])}
                                    isMulti
                                    isSearchable
                                    isClearable
                                    closeMenuOnSelect={false}
                                    placeholder="Choose Item"
                                    styles={selectStyles}
                                />
                            </Box>
                        </Grid>

                        {/* CHANGED: Button Width 2 columns (5+5+2 = 12) */}
                        <Grid item xs={12} sm={2} md={2} lg={2} sx={{ display: 'flex', justifyContent: isMobile ? 'flex-start' : 'flex-end' }}>
                            <SSPCommonButton btnText={"Download"} btnFunction={() => handleDownloadFile()}
                            />
                        </Grid>
                    </Grid>

                </CardContent>

                <Card sx={{ ...styles.provisiontablecard, paddingHorizontal: 0 }} >
                    <CardHeader
                        p={2}
                        sx={styles.cardHeader}
                        title={"Uploaded Files"}
                        titleTypographyProps={{
                            sx: { fontSize: "16px", fontWeight: "600", lineHeight: "16px", color: "#0160F1", },
                        }}
                        action={
                            <>
                                <Button onClick={() => window.location.reload()}>
                                    Refresh Page
                                </Button>
                            </>
                        }
                    />
                    <Divider />
                    <CardContent sx={styles.assetmasterCardContent} >
                        <Box
                            sx={{
                                backgroundColor: "#FFFFFF",
                                borderBottomRightRadius: "5px",
                                borderBottomLeftRadius: "5px",
                                padding: isMobile ? "8px" : "16px",
                                height: 700,
                            }}
                        >
                            <DataGrid
                                rowHeight={80}
                                showCellRightBorder={true}

                                sx={{
                                    ".MuiDataGrid-columnHeaderTitle": {
                                        fontWeight: "bold !important",
                                        fontSize: isMobile ? "0.7rem" : "0.875rem",
                                    },
                                    ".MuiDataGrid-cell": {
                                        fontSize: isMobile ? "0.6rem" : "0.8rem",
                                        padding: isMobile ? "4px" : "8px",
                                    },
                                    ".MuiDataGrid-root": {
                                        minWidth: isMobile ? "50%" : "auto",
                                    },
                                    overflowX: "auto",

                                }}
                                rows={row}
                                columns={columns}

                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 10,
                                        },
                                    },
                                }}
                                headerClassName="header-center"
                                rowsPerPageOptions={[10]}
                                pageSize={10}
                                getRowId={(row) => row.id}
                                components={{
                                    Toolbar: GridToolbar,
                                }}
                                componentsProps={{
                                    Toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: { debounceMs: 500 },
                                    },
                                }}
                            />
                        </Box>
                        {modalOpener && (
                            <SSPCommonModal
                                open={modalOpener}
                                handleOpenClose={setmodalOpener}
                                message={message}
                            />
                        )}
                    </CardContent>
                </Card>
            </Card>


        </Box>
    )
}

export default CreateProvisions
